<template>
  <div class="container careeDetail">
    <h3>{{careeData.jobName}}</h3>
    <div class="item_common duty">
      <h4>岗位职责：</h4>
      <ul>
        <li v-for="item in dutyData">{{item}}</li>
      </ul>
    </div>
    <div class="item_common demand">
      <h4>岗位要求：</h4>
      <ul>
        <li v-for="item in demandData">{{item}}</li>
      </ul>
    </div>
  </div>
</template>
<script>
var careeDetail = [{
  id: 1,
  jobName: '前端工程师',
  demand: '本科及以上学历，计算机软件相关专业（软件工程、计算机科学与技术等），具备良好的Web基础、数据结构和算法、Java等知识，2年以上工作经验（但是必须有5年以上编程经验、3年以上Web开发经验）;精通前端基础技术，能够不依靠框架仅使用HTML、JavaScript、CSS开发复杂Web应用，对浏览器兼容性、前端交互设计、前端性能优化、用户体验等有深入认识;熟悉CommonJS和AMD规范，了解ECMAScript 6和TypeScript等新语法，精通jQuery，熟悉ReactJs、Angular2等新型JavaScript框架，能够快速地掌握前端新兴技术;熟悉CommonJS和AMD规范，了解ECMAScript 6和TypeScript等新语法，精通jQuery，熟悉ReactJs、Angular2等新型JavaScript框架，能够快速地掌握前端新兴技术;熟悉Node.js及其相关的开发工具链;熟悉常用的Java Web实现方式如SSH，熟悉Web前后端分离的工作流程，熟悉前端与后台的数据交互;热爱前端，能够灵活运用代码的可重用性和可维护性，具备强烈的责任心，具备良好的学习能力、问题解决能力、沟通能力、英文阅读能力、文档编写能力',
  duty: '研发前端通用基础组件（UI设计和功能实现）;研发前端通用功能模块;复杂前端应用的后端协助处理逻辑开发;参与项目和产品前端相关技术难点的研究与攻关;开源技术的二次开发;改进前端技术和框架;为开发人员提供技术培训和技术指导'
}, {
  id: 2,
  jobName: 'UI设计师',
  demand: '美术,设计相关专业，参与过客户端、移动端产品至少3年以上UI产品设计经验;精通Photoshop等设计软件， 熟悉掌握PC、web、iOS、Android人机界面的设计原则和交互规范;对视觉规范和用户交互的审美需求有深刻的理解，能把控项目的整体UI形象;具有前瞻性设计理念，了解并熟悉国内外流行趋势;具有较深厚的美术功底和良好的创意构思能力;具备良好合作态度及团队精神，并富有工作激情',
  duty: '负责品牌PC端及移动应用端的UI设计工作;根据产品需求，提炼符合时尚趋势与用户体验的UI方案;熟悉移动互联网用户使用习惯，重视用户体验，积极主动提升产品交互的易用性与友好性;参与产品构思及交互界面优化，提出优化的见解;能积极与开发沟通，推进界面及交互设计最终实现;根据品牌的特点，提出构思新颖、有高度吸引力的创意设计'

}, {
  id: 3,
  jobName: 'java工程师',
  demand: '本科及以上学历，计算机相关专业，3年以上相关工作经验;JAVA基础扎实，熟悉面向对象设计，熟悉MYSQL数据库设计和调优，熟练使用maven/git/eclipse/junit/tomcat等常用工具，面对复杂需求有抽象设计和分解目标的能力;熟悉主流框架，有Spring MVC/Spring boot/JPA/querydsl的实战经验的优先、熟悉Spring Cloud框架，有微服务分布式架构实战开发经验的优先，有大型后台系统开发经验者优先',
  duty: '参与服务器端项目开发，根据需求实现产品功能，为前端工程师提供数据接口;编写自己开发的代码的单元测试用例代码;参与项目开发文档的维护工作'
}]
export default {
  name: "index",
  data() {
    return {
      careeData: [],
      dutyData: [],
      demandData: []
    }
  },
  mounted() {
    let id = this.$route.query.id
    careeDetail.map((item) => {
      if (item.id == id) {
        console.log(item.jobName)
        this.careeData = item
        this.dutyData = item.duty.split(';')
        this.demandData = item.demand.split(';')
      }
    })

  },
}
</script>

<style scope lang='less' src='./../index.less'>
</style>



// WEBPACK FOOTER //
// src/page/Career/Detail/index.vue